module.exports = __webpack_public_path__ + "tinymce.svg?d031f47facf4331979b6f9fbac3187ef";